import { jsx as _jsx } from "react/jsx-runtime";
import * as Colors from './colors';
import { split } from './common';
export function renderCs(source) {
    const parts = split(source);
    const result = [];
    const keyWords = ['if', 'else', 'switch', 'case', 'default', 'for', 'foreach', 'while', 'do', 'break', 'continue', 'return',
        'try', 'catch', 'finally', 'throw', 'new', 'class', 'interface', 'abstract', 'private', 'protected',
        'public', 'static', 'readonly', 'const', 'var', 'enum', 'namespace', 'using', 'this', 'struct', 'yield', 'async', 'await', 'get', 'set', 'value', 'event', 'delegate', 'params',
        'int', 'string', 'bool', 'object', 'decimal', 'float', 'double', 'long', 'short', 'byte', 'sbyte', 'uint', 'ulong', 'ushort', 'char', 'void', 'null', 'true', 'false'];
    let isString = false;
    for (const token of parts) {
        if (keyWords.indexOf(token) >= 0) {
            result.push(_jsx("span", { style: { color: Colors.elementColor }, children: token }));
            continue;
        }
        else if (token === '(' || token === ')' || token === '{' || token === '}' || token === '[' || token === ']') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            continue;
        }
        if (token === '"' || token === '\'') {
            result.push(_jsx("span", { style: { color: Colors.attributeValueColor }, children: token }));
            isString = !isString;
            continue;
        }
        result.push(_jsx("span", { style: { color: isString ? Colors.attributeValueColor : Colors.defaultColor }, children: token }));
    }
    return result;
}
